import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';

import { requiredValidation, withFormEventValidation } from '../../validatableComponent';
import { FormTextarea } from '../../FormTextarea';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const ValuesFormInput = withFormEventValidation(FormTextarea, requiredValidation);

type ComponentState = State['emConfiguration']['perItemPurchased'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};

const PerItemPurchasedConfiguration: React.FC<Props> = (props) => {
  const { itemKey, summationMode, values, countPer, fieldDisabled } = props;

  return (
    <Box>
      <Box my={4}>
        <ButtonGroup
          label='Summation Mode'
          name='summationMode'
          readonly={fieldDisabled('summationMode')}
          selectedValue={summationMode}
        >
          <ButtonGroup.Option value='include'>Include</ButtonGroup.Option>
          <ButtonGroup.Option value='exclude'>Exclude</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Count Per'
          name='countPer'
          readonly={fieldDisabled('countPer')}
          selectedValue={countPer}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Line item key'
          name='itemKey'
          readonly={fieldDisabled('itemKey')}
          selectedValue={itemKey}
        >
          <ButtonGroup.Option value='group'>Group</ButtonGroup.Option>
          <ButtonGroup.Option value='upc'>UPC</ButtonGroup.Option>
          <ButtonGroup.Option value='sku'>SKU</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ValuesFormInput
          id='values'
          label='Enter Product Values'
          readonly={fieldDisabled('values')}
          value={values.join(', ')}
          required={true}
        />
        <Typography variant='body2'>Enter a comma seperated list of values</Typography>
      </Box>
    </Box>
  );
};

export { PerItemPurchasedConfiguration };
